// Domain-based tenant resolution: on app.<brand>.ch the portal is auto-detected
// from the hostname (config-driven via portal.app_domain). Falls back to null in
// the preview / central context, where the route param (/p/:portalKey) is used.
export function resolvePortalKeyFromHost(portals) {
  if (typeof window === "undefined") return null;
  const host = window.location.hostname.toLowerCase();
  const match = (portals || []).find(
    (p) => p.app_domain && host === String(p.app_domain).toLowerCase()
  );
  return match ? match.portal_key : null;
}
